module.exports = __webpack_public_path__ + "img/company_logo.eb025139.png";